import React, { Component } from 'react';
import './Gallery.css'

class Gallery extends Component {

    render() {
        return (
            <div className="row justify-content-center">
                <div className="outer-container square" style={{ height: this.props.windowSize }}>
                    <div className="inner-container" style={{ width: this.props.gallerySize }}>
                        <div className="inner-grad" style={{ height: this.props.windowSize }}></div>
                    </div>
                </div>
            </div>
        )
    }
}


export default Gallery;